export default {
    top_menu: [
        {name:'Ең бастысы', id:0},
        {name:'Шоу-Бизнес', id:1},
        {name:'тамақ',  id:2},
        {name:'Саясат',   id:3},
        {name:'+18',  id:4},
        {name:'Қоғам',   id:5},
        {name:'Денсаулық',   id:6},
    ],
    read_other: 'Ары қарай оқу',
    read_more:  'Толығырақ',
    not_found:  'Ештеңе табылмады',
    read_also:  'Сондай -ақ оқыңыз',
    copy_rights: 'Copyright © 2019 «mixer-novostei.ru». Барлық құқықтар сақталған.',
    subscribe: 'Жазылу',

    thank_order: 'СІЗДІҢ ТАПСЫРЫС ҮШІН РАХМЕТ',
    specialist_contact: 'Біздің маман сізге жақын арада хабарласады, қоңырауды күтіңіз.',
    attention: 'Серіктестерден жеңілдіктер:',
    hurry: 'Асықшы, жеңілдіктерді қосу уақыты шектеулі! Осы бірегей өнімдердің біреуін таңдауға <span id="time" class="time">30:00</span> минут қана беріледі:',

    hour_ago1: "бір сағат бұрын",
    hour_ago2: "сағат бұрын",
    hour_ago3: "сағат бұрын",
    new_publications: "Жаңа басылымдар",
    read: "Оқыңыз",
    today_at: "Бүгін сағат",
    author_names: ['Аша Матай','Мухит Мералыулы','Торегали Тореали'],
    main_news: "Негізгі жаңалық",
    leave_already: "Қазірдің өзінде кетіп жатырсыз ба? Күте тұрыңыз, біз сіз үшін жаңалықты жаңарттық",
    already_shared: "бөліскен"
}